import yuni from "../Assets/images/porto/yuni.webp";
import feed from "../Assets/images/porto/feed.webp";
import ubud from "../Assets/images/porto/ubud.webp";
import eLib from "../Assets/images/porto/e-lib.webp";
import sunset from "../Assets/images/porto/sunset.png";
import ciak from "../Assets/images/porto/ciak.png";
import moneychanger from "../Assets/images/porto/moneychanger.png";
import equo from "../Assets/images/porto/equo.png";
import cayman from "../Assets/images/porto/cayman-landing.png";

const users = {
  blue: true,
  red: false,
  purple: false,
  green: false,
  datas: [
    {
      category: "Website - HUMAN Resource Information System",
      title: "HRIS Sunset Dental",
      desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit molestiae assumenda harum, expedita maxime ipsum ea veniam vel iusto non?",
      link: "sunset-dental",
      image: sunset,
    },
    {
      category: "Website - Landing Page",
      title: "Weeding Invitation",
      desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit molestiae assumenda harum, expedita maxime ipsum ea veniam vel iusto non?",
      link: "turah-yuni",
      image: yuni,
    },
    {
      category: "Website - Social Media",
      title: "CIAK LIVE",
      desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit molestiae assumenda harum, expedita maxime ipsum ea veniam vel iusto non?",
      link: "ciak-live",
      image: ciak,
    },
    {
      category: "Website - Money Changer",
      title: "Money Changer Ubud",
      desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit molestiae assumenda harum, expedita maxime ipsum ea veniam vel iusto non?",
      link: "money-changer-ubud",
      image: moneychanger,
    },
    {
      category: "Design - Instagram Feed",
      title: "Design Feed Instagram",
      desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit molestiae assumenda harum, expedita maxime ipsum ea veniam vel iusto non?",
      link: "feed-saydanco",
      image: feed,
    },
    {
      category: "Website - E Wallet",
      title: "Equo Transfer",
      desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit molestiae assumenda harum, expedita maxime ipsum ea veniam vel iusto non?",
      link: "equo-transfer",
      image: equo,
    },
    {
      category: "Website - Landing Page",
      title: "Cayman Financial Group",
      desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit molestiae assumenda harum, expedita maxime ipsum ea veniam vel iusto non?",
      link: "cayman-financial-group",
      image: cayman,
    },
    {
      category: "Web Design - Landing Page",
      title: "Web Design Wisata Ubud",
      desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit molestiae assumenda harum, expedita maxime ipsum ea veniam vel iusto non?",
      link: "wisata-ubud",
      image: ubud,
    },
    {
      category: "Website - Landing Page",
      title: "Website Bootcamp E-Library",
      desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit molestiae assumenda harum, expedita maxime ipsum ea veniam vel iusto non?",
      link: "e-library",
      image: eLib,
    },
  ],
};

export const states = {
  ...users,
  // ...data
};
